<template>
    <div>
         <!-- fee name -->
        <div class="flex items-center mb2">
            <div class="w-100">
                <LabeledControl label="Fee Name">
                    <div class="flex">
                        <Textbox v-model="fee.name" placeholder="e.g. Service Fee, Cleaning Fee"/>
                        <img @click="$emit('delete')" class="ml3" src="@/assets/img/icon_listmytools_remove.svg"/>
                    </div>
                </LabeledControl>
            </div>
        </div>

        <!-- fee amount -->
       <LabeledControl class="mb2" label="Amount">
            <CurrencyInput v-model="fee.amount"/>
        </LabeledControl>

        <!-- fee description -->
        <LabeledControl class="mb3" label="Fee Description">
            <textarea v-model="fee.description" class="pa3 w-100 ba b--light-gray" rows="4" placeholder="Describe the purpose of the fee."></textarea>
        </LabeledControl>

    </div>
</template>

<script>
import LabeledControl from '@/components/controls/LabeledControl.vue';
import CurrencyInput from '@/components/controls/CurrencyInput.vue';
import Textbox from '@/components/controls/Textbox.vue';

export default {
    components: {
        CurrencyInput,
        LabeledControl,
        Textbox
    },
    props: {
        fee: {
            type: Object
        }
    }
};
</script>
